module.exports = __webpack_public_path__ + "2880bd7ebac6a706d6f114765ca9d7d3.svg";